var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/features/compose/components/schedule_button.tsx";
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import ComposeFormButton from './compose_form_button';
const messages = defineMessages({
  add_schedule: {
    "id": "schedule_button.add_schedule",
    "defaultMessage": "Schedule post for later"
  },
  remove_schedule: {
    "id": "schedule_button.remove_schedule",
    "defaultMessage": "Post immediately"
  }
});
const ScheduleButton = ({
  active,
  unavailable,
  disabled,
  onClick
}) => {
  const intl = useIntl();
  const handleClick = () => {
    onClick();
  };
  if (unavailable) {
    return null;
  }
  return /*#__PURE__*/React.createElement(ComposeFormButton, {
    icon: require('@tabler/icons/calendar-stats.svg'),
    title: intl.formatMessage(active ? messages.remove_schedule : messages.add_schedule),
    active: active,
    disabled: disabled,
    onClick: handleClick,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 30,
      columnNumber: 5
    }
  });
};
export default ScheduleButton;